import { MutableRefObject, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { UserContentLayout } from '../../components/Layouts/UserContentLayout';
import { RadarChart } from '../../components/User/RadarChart';
import { useRequest, useScore, useToast, useToggle } from '../../hooks';
import { UserConfirmResetScore } from '../../components/Modals/UserConfirmResetScore';
import { API_ROUTERS } from '../../data';
import { RemoveBtn } from '../../components/Buttons/RemoveBtn';
import { CardWithShadow } from '../../components/User/CardWithShadow';
import { Box, Flex, VStack } from '@chakra-ui/react';
import { RADAR_LINES } from '../../data/scoreRadar';
import { ScoreCard } from '../../components/User/ScoreCard';

const UserScoreCard = () => {
  const { t } = useTranslation();
  const [userScore, setUserScore] = useState<(number | string)[]>([]);
  const { fetchScore } = useScore();
  const { show, hide, isShow } = useToggle();
  const { authRequest } = useRequest();
  const { showToast } = useToast();

  const isMount: MutableRefObject<boolean> = useRef(false);

  useEffect(() => {
    const loadScore = async () => {
      const score = await fetchScore();
      setUserScore(score || []);
    };

    if (!isMount.current) {
      isMount.current = true;
      loadScore();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onConfirmReset = async () => {
    try {
      await authRequest({ method: 'post', url: API_ROUTERS.RESET_SCORE });
      hide();
      setUserScore([]);
      showToast({ type: 'success', message: `${t('toast.score.success.reseted')}` });
    } catch (e) {}
  };

  return (
    <>
      <UserContentLayout caption={`${t('score.page.header')}`}>
        <Flex flexWrap='wrap' maxW='5xl' justifyContent='space-between'>
          <Box w='100%' textAlign='right' py={4}>
            <RemoveBtn onClick={show}>{t('score.page.reset.btn')}</RemoveBtn>
          </Box>

          <CardWithShadow
            w={{ base: '100%', lg: '67%' }}
            mb={{ base: 6, lg: 0 }}
            display='flex'
            justifyContent='center'
            alignItems='center'
          >
            <RadarChart
              userResults={userScore}
              maxWidth={{ base: '600px', lg: '68vh' }}
              p={{ base: '20%', sm: '15%', xl: '10%' }}
            />
          </CardWithShadow>

          <VStack w={{ base: '100%', lg: '30%' }} spacing={4}>
            {RADAR_LINES.map(({ labelKey, icon }, i) => (
              <ScoreCard key={labelKey} value={Number(userScore[i])} icon={icon} labelKey={labelKey} />
            ))}
          </VStack>
        </Flex>
      </UserContentLayout>

      {/* ──── Modals ──────────────────────────────────────────────────────────────────────────── */}
      <UserConfirmResetScore isOpen={isShow} onClose={hide} onConfirm={onConfirmReset} />
    </>
  );
};

export default UserScoreCard;
